document.addEventListener("DOMContentLoaded", function () {
  const openBtns = document.querySelectorAll(".openbtn"); // 開閉ボタン
  const spMenu = document.getElementById("sp-menu"); // メニュー
  const headerHide = document.getElementById("mdl-header-hide"); // 非表示ヘッダー部分
  const headerHidePc = document.getElementById("mdl-header-hide-pc"); // 非表示ヘッダー部分
  const body = document.body;
  let isFixed = false;

  // 🔹 メニュー開閉
  openBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      const isMenuOpen = spMenu.classList.toggle("show");
      body.classList.toggle("no-scroll", isMenuOpen);

      // クリックされたボタンのみアイコン切り替え
      btn.classList.toggle("menu-open", isMenuOpen);
    });
  });

  // 🔹 スクロールでヘッダー固定（メニュー開いてる間は固定無効）
  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY || window.pageYOffset;

    // ▼ headerHideの処理（既存）
    if (scrollY > 100) {
      if (!isFixed) {
        headerHide.classList.add("mdl-header-fixed-hide");
        spMenu.style.top = "60px"; // ← 位置調整
        isFixed = true;
      }
    } else {
      if (isFixed) {
        headerHide.classList.remove("mdl-header-fixed-hide");
        spMenu.style.top = "";
        isFixed = false;
      }
    }

    // ▼ 画面幅1350px以上のとき
    if (window.innerWidth >= 1350) {
      if (scrollY > 150) {
        headerHidePc.classList.add("mdl-header-fixed");
      } else {
        headerHidePc.classList.remove("mdl-header-fixed");
      }
    } else {
      // 1350px未満では確実に外す
      headerHidePc.classList.remove("mdl-header-fixed");
    }
  });

  // 商品詳細ページのアコーディオン
  const accordions = document.querySelectorAll(".mdl-product-info-accordion");

  accordions.forEach((accordion) => {
    const title = accordion.querySelector(".mdl-product-info-accordion__title");
    const content = accordion.querySelector(
      ".mdl-product-info-accordion__content"
    );
    const icon = accordion.querySelector(".mdl-product-info-accordion__icon");

    content.style.overflow = "hidden";
    content.style.transition = "max-height 0.3s ease";

    const startClosed = accordion.dataset.initial === "closed";
    if (startClosed) {
      content.style.maxHeight = "0";
      icon.classList.remove("mdl-product-info-accordion__icon--open");
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      icon.classList.add("mdl-product-info-accordion__icon--open");
    }

    title.addEventListener("click", () => {
      const isOpen = content.style.maxHeight !== "0px";

      if (isOpen) {
        content.style.maxHeight = "0";
        icon.classList.remove("mdl-product-info-accordion__icon--open");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        icon.classList.add("mdl-product-info-accordion__icon--open");
      }
    });
  });
});
